import React from 'react';
import '../Routes.css';

function Faq() {
  return (
    <div className="page__container">
      <h1 className="page__heading">FAQ</h1>
    </div>
  );
}

export default Faq;
